import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CustomLineChart from "./../components/CustomLineChart";
import ArrowIcon from "./../components/ArrowIcon";
import UserProfile from "./../../components/UserProfile";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import {
  borderRadius,
  fontSize,
  fontWeight,
  height,
  width,
} from "@material-ui/system";
// import Chart from "./Chart";
import { formatDateRange, getCurrentPeriod, getPriorPeriod, getRangeEnd, getRangeStart } from "../../../exportreport/utils";

const apiURL = process.env.API_ROOT;

const calculatePercentageChange = (
  newValue,
  oldValue,
  reverseColors = false
) => {
  if (oldValue === 0) {
    return <span>--</span>;
  }

  const percentageChange = ((newValue - oldValue) / oldValue) * 100;
  const roundedChange = Math.round(percentageChange * 10) / 10; // Round to nearest 1 decimal place

  // Determine the direction and set icon and color
  let icon = "";
  let color = "";

  if (roundedChange > 0) {
    icon = "â¬†"; // Up arrow icon
    color = reverseColors ? "stat-down" : "stat-up"; // Reversed color if reverseColors is true
  } else if (roundedChange < 0) {
    icon = "â¬‡"; // Down arrow icon
    color = reverseColors ? "stat-up" : "stat-down"; // Reversed color if reverseColors is true
  } else {
    icon = "âž–"; // No change icon
    color = "gray"; // Neutral color for no change
  }

  return (
    <span className={color}>
      {icon} {Math.abs(roundedChange)}%
    </span>
  );
};
const validateNestedData = (obj, path) => {
  const keys = path.split(".");
  let current = obj;

  for (let key of keys) {
    if (current[key] === undefined) {
      return false;
    }
    current = current[key];
  }

  return true;
};


let statTypes = [
  {
    key: "all",
    title: "Unsold Sponsor Units",
    name: "New Dev Inventory",
    checkedColor: "#D5E1A3",
    activitesQuery:'(event_tags:(event-stage_sponsor) AND -address_2_normalized:"")',
    default: true,
  }
];

const statFacet = {
  avg_price: "avg(price)",
  med_price: "percentile(price, 50)",
  sum_price: "sum(price)",
  by_borough: {
    type: "terms",
    field: "borough",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
    },
  },
  ppsf: {
    type: "query",
    q: "sq_ft:[300 TO 20000]",
    facet: {
      avg: "avg(div(price, sq_ft))",
      med: "percentile(div(price, sq_ft), 50)",
    },
  },
  price_change: {
    type: "query",
    q: "price_change_amount:*",
    facet: {
      avg: "avg(price_change_amount)",
      percent: "avg(price_change_percent)",
      sum: "sum(price_change_amount)",
    },
  },
  dom: {
    type: "query",
    q: "days_on_market:[3 TO 720]",
    facet: {
      avg: "avg(days_on_market)",
      med: "percentile(days_on_market, 50)",
    },
  },
  under_one: {
    type: "query",
    q: "price:[10000 TO 999999]",
  },
  one_to_two: {
    type: "query",
    q: "price:[1000000 TO 1999999]",
  },
  two_to_four: {
    type: "query",
    q: "price:[2000000 TO 3999999]",
  },
  four_to_ten: {
    type: "query",
    q: "price:[4000000 TO 9999999]",
  },
  ten_plus: {
    type: "query",
    q: "price:[10000000 TO 350000000]",
  },
};

const Layout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    reportHeader,
    logo,
    formValues,
    defaultLogo
  } = props;

  const { dateOptions, theme, branding } = customDate;
 

  const generatePeriodNames = () => {
    const { startDate, endDate, previousStartDate, previousEndDate } =
      dateOptions;
    const currentPeriod = formatDateRange(startDate, endDate);

    const priorPeriod = formatDateRange(previousStartDate, previousEndDate);

    const priorYearStartDate = startDate.clone().subtract(1, "year");
    const priorYearEndDate = endDate.clone().subtract(1, "year");

    const priorYearPeriod = formatDateRange(
      priorYearStartDate,
      priorYearEndDate
    );
    return {
      currentPeriod,
      priorPeriod,
      priorYearPeriod,
    };
  };

  const currentPeriod =getCurrentPeriod(dateOptions)
  const priorPeriod = getPriorPeriod(dateOptions)
  const priorYearPeriod = priorPeriod;
  const rangeEnd =getRangeEnd(dateOptions)
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;

  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      handleCombinedAPIRequests();
    }
  }, [submit]);

  const dataFacet = {
    contract_signed: {
      type: "query",
      q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              dom: {
                type: "query",
                q: "days_on_market:[3 TO 720]",
                facet: {
                  avg: "avg(days_on_market)",
                  med: "percentile(days_on_market, 50)",
                },
              },
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    new_listings: {
      type: "query",
      q: "topic:listings AND event_tags:just-listed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    recorded_sold: {
      type: "query",
      q: "topic:transactions AND event_tags:recorded-sale AND -event_tags:*commercial* AND  -event_tags:property-type_parking-space AND -event_tags:property-type_storage-room AND -event_tags:parcels_bulk-sale",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
  };
  
  const getInventory = async () => {
      let q = "*:*";
      let locQuery = _tranformTagsQuery(searchTags);
  
      if (locQuery) {
          q = locQuery;
      }
      setFetchInProgress(true);
  
      let query = {
          "q": q,
          "fq": [
              "deleted:false",
              "{!join from=alternate_keys fromIndex=we3-buildings to=building}(((offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_verified_status:(active \"coming soon\" \"offering plan required\" \"offering plan acquired\" \"condo declaration vetted\")) AND offering_verified_status:(\"\" \"monitoring\" \"reviewed\" \"offering plan required\" \"offering plan acquired\" \"condo declaration vetted\" \"vetting required\" \"vetted\" \"coming soon\" \"active\" \"sold out\") AND deleted:false AND building_status:(pipeline)) OR ((offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_verified_status:(active \"coming soon\" \"offering plan required\" \"offering plan acquired\" \"condo declaration vetted\")) AND offering_verified_status:(\"\" \"monitoring\" \"reviewed\" \"offering plan required\" \"offering plan acquired\" \"condo declaration vetted\" \"vetting required\" \"vetted\" \"coming soon\" \"active\" \"sold out\") AND deleted:false AND building_status:(sponsor)) OR ((ownership_type:(*condo*) AND -ownership_type:condop AND property_category:(resi* mixed*use) AND -full_street_address:\"\" AND -full_street_address:/.* garage .*/ AND number_of_buildings:[1 TO *] AND (condo_num:['1' TO *] OR (offering_verified_status:active AND building_status:resale)) AND ((tax_assessed_residential_units:[1 TO *] OR building_class:R3 OR (offering_verified_status:active AND building_status:resale)) AND -building_class:R9) AND -offering_verified_status:\"excluded\" AND deleted:false) AND building_status:resale) OR (ownership_type:(*co?op* *coop* condop*) AND number_of_buildings:[1 TO *] AND -ownership_occupancy_type:rental) OR ((ownership_type:(single?family multi?family) AND total_units:[1 TO 6]) OR (ownership_type:rental AND total_units:[* TO 3])))",
              "-offering_unit_abandoned:true",
              "-offering_verified_status:stalled"
          ],
          "rows": 0,
          "start": 0,
          "wt": "json",
          "json.facet": {
              "unsold": {
                  "type": "query",
                  "q": "((offering_verified_status:active AND source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:\"\" AND -address_2_normalized:\"\") OR (current_status:(active \"in contract\")) OR (verification_source:(user-verified-valid CDEC ADEC NYCDOF) AND -address_2_normalized:\"\") OR building_class:R3) AND (current_status:((active) OR (current_status:shadow AND -offering_construction:conversion AND property_status:sponsor AND (offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW])) OR (current_status:transfer AND -offering_construction:conversion AND property_status:sponsor AND (offering_submitted_date:[2010-11-01T00:00:00Z TO NOW] OR offering_accepted_date:[2010-11-01T00:00:00Z TO NOW])))) AND (property_type:((*residential*condo* condo \"condo unit\" \"resident manager unit\" *coop* *affordable* \"\" *dwelling* *timeshare* *residential* *apartment*))) AND property_status:(\"sponsor\") AND (source_organizations:(NYAG CDEC ADEC) OR verification_source:(user-verified-valid CDEC ADEC NYCDOF) OR current_status:active) AND -address_2_normalized:\"\"",
                  "facet": {
                      "buildings": "unique(building)",
                      "active": {
                          "type": "query",
                          "q": "current_status:active"
                      }
                  }
              },
              current_period: {
                type: "query",
                q: `offering_accepted_date:${currentPeriod} AND -address_2_normalized:"" AND baths:[1 TO *]`
              },
              prior_year_period: {
                type: "query",
                q: `offering_accepted_date:${priorYearPeriod} AND -address_2_normalized:"" AND baths:[1 TO *]`
              },
          }
      };
      
      let axiosData = {
          url: apiURL + "/query/we3-properties",
          method: "post",
          query: query,
      };
  
      return _axiosCall(axiosData)
          .then((res) => {
              if (res && res.facets) {
                  setFetchInProgress(false);
              }
              return res;
          })
          .catch((error) => {
              console.log("error: " + error);
          });
  };

  const loadData = async () => {
      let q = "*:*";
      let locQuery = _tranformTagsQuery(searchTags);
  
      if (locQuery) {
          q = locQuery;
      }
  
      const defaultQ = getCohortQuery(user, true);
      const fq = [
          ..._activityFQ.slice(),
          ...[`{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`],
      ];
      setFetchInProgress(true);
  
      let facet = {};
      statTypes.map((item) => {
          facet[item.key] = {
              "type": "query",
              "q": item.activitesQuery,
              "facet": dataFacet,
          };
      });
  
      let axiosData = {
          url: apiURL + "/query/we3-activities-3",
          method: "post",
          query: {
              q: q,
              fq: fq,
              wt: "json",
              rows: 0,
              "json.facet": facet,
          },
      };
  
      return _axiosCall(axiosData)
          .then(async (res) => {
              
              return res;
          })
          .catch((error) => {
              console.log("error: " + error);
          });
  };
  
  const handleCombinedAPIRequests = async () => {
      try {
          const [inventoryData, res] = await Promise.all([getInventory(), loadData()]);
  
          let aiData;
          console.log(inventoryData, res)
          if (res && res.facets) {
            if(inventoryData && inventoryData.facets){
              res.facets["inventory"] = inventoryData.facets;
            }
            //aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
            // const aiResponse = await handleAIGenerate(aiData);
            // res["aiResponse"] = aiResponse;
            setFetchInProgress(false);
            setReportLoaded(true);
            setSubmit(false);
            setReportData(res);
          }
          return res;
          
      } catch (error) {
          console.error('Error in combined API requests:', error);
          setFetchInProgress(false);
      }
  };
  const handleAIGenerate = async (data) => {
    const prompt = `Given the following data give me an analysis that speaks to current period trends vs prior periods, the chart contains more history.  The analysis should be 3 or 4 concise sentences for each of the root notes under facts  contracts_signed, recorded_sold and new_listings in JSON format.  The analysis should be easy to understand for consumer audiences.  For contracts_signed focus only on the count of contracts and days on market (dom), for recorded_sold ignore number and focus on prices.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  Also include 5 concise bullet points that summarizes the key metrics and analysis, the bullets should be easy to understand headlines and engaging.  The results should be in valid raw JSON format, no formatting.  { "contract_signed" : "analysis in text", recorded_sold : "analysis in text", new_listings: "analysis in text", summary_bullets: ["bullet point 1", "bullet point 2"] }
    
    The report contains the following key stats:${JSON.stringify(data)}`;

    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV or news analysts.`,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o",
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        //console.log(result);
        try {
          aiResponse = JSON.parse(result);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };


  if (!reportData) return null;
console.log(reportData)
  const data = [
    { name: "Change", value: "-1.85%" },
    { name: "Avg Price", value: "$1.74M" },
    { name: "Avg PPSF", value: "$1,135" },
  ];
  
 
    
  const PropertyTypePage = (props) => {
    const { name, title, type } = props;
    const hasLocation = searchTags && searchTags.length>0;
    const isPos = (validateNestedData(
      reportData,
      `facets.${type.key}.contract_signed.current_period.count`
    ) &&
    validateNestedData(
      reportData,
      `facets.${type.key}.contract_signed.prior_year_period.count`
    )
      ? reportData.facets[type.key].contract_signed.current_period.count >= reportData.facets[type.key].contract_signed.prior_year_period.count
      : true);
    const chartData =  validateNestedData(
      reportData,
      `facets.${type.key}.contract_signed.chart`
    )
      ? reportData.facets[type.key].contract_signed.chart.buckets.slice(reportData.facets[type.key].contract_signed.chart.buckets.length - 13, reportData.facets[type.key].contract_signed.chart.buckets.length).map(item => ({year : formatDateRange(null, null, item.val), price: item.count ? Math.round(item.count) : 0})) : [];
      return (
        <>
          <div
            className="social-media-report-container page-section"
          >
            <section className="social-branding">
              {branding && branding && branding === "mylogo" && logo ? (
                <div className="brand-logo">
                  <div>
                    <img
                      className="header-logo"
                      src={logo}
                      style={{ maxHeight: 70 }}
                    />
                  </div>
                </div>
              ) : branding && branding && branding === "marketproof" ? (
                <div className="brand-logo">
                  <div>
                    <img
                      src={defaultLogo}
                      style={{ maxHeight: 70 }}
                    />
                  </div>
                </div>
              ) : null}
              <UserProfile formValues={formValues} user={user} />
            </section>
            <section className="social-section">
             <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
             <div className="heading editable">{type.name}</div>
             
             <div className="sub-header-wrapper">
              <div className="sub-header-type editable">{type.title}</div>
              <div className="sub-header-type date editable">{currentPeriodName}</div>
             </div>
             
              
              <div className="content-wrapper">
                <h3>{validateNestedData(reportData, `facets.inventory.unsold.count`)  ? _formatNumber(reportData.facets.inventory.unsold.count) : "--"}</h3>
                {/* <ArrowIcon isPositive={isPos} /> */}
                <div className="grid-layout">
                  <div  className="row">
                    <div>Unlisted</div>
                    <div>{validateNestedData(reportData, `facets.inventory.unsold.active.count`)  ? Math.round(((reportData.facets.inventory.unsold.count-reportData.facets.inventory.unsold.active.count)/reportData.facets.inventory.unsold.count) * 100) + "%" : "--"}</div>
                  </div>
                  <div  className="row">
                    <div>Active</div>
                    <div>{validateNestedData(reportData, `facets.inventory.unsold.active.count`)  ? _formatNumber(reportData.facets.inventory.unsold.active.count) : "--"}</div>
                  </div>
                  
                  <div  className="row">
                    <div>Shadow</div>
                    <div>{(validateNestedData(reportData, `facets.inventory.unsold.active.count`)  ? _formatNumber((reportData.facets.inventory.unsold.count - reportData.facets.inventory.unsold.active.count)) : "--")}</div>
                  </div>
                 
                </div>
              </div>
              <div className="social-chart">
              <p className="sub-header-type">New Dev Contracts</p>
              <CustomLineChart
                theme={theme}
                data={chartData}
              />
              </div>
            </section>
          </div>
        </>
      );
    }
    
    if (!reportData) return null;
    return (
      <>
      {statTypes.map(type => {
        
        return <PropertyTypePage type={type} />
        
      })}
      </>
    )
};

export default Layout;
